import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Tabs, Tab } from 'react-bootstrap';

import { Link } from 'react-router-dom';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

// Tabs
import PaymentDailyOpenedNational from './PaymentDailyOpenedNational';
import PaymentDailyOpenedInternational from './PaymentDailyOpenedInternational';

class PaymentDailyOpened extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      key: 1,
      loaded: 0,
      training_certification_staff_payments_national: [],
      training_certification_staff_payments_international: [],
      payment_orders_list: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
  }
  // Handlers
  handleNavTab(state, key) {
    var change = {};
    change[state] = key;
    this.setState(change);
    this.setState({overlay: {message: '', type: '', status: ''}});
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  //LM
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/pagamentos/abertos/diarias/nacionais';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({training_certification_staff_payments_national: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/pagamentos/abertos/diarias/internacionais';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
            self.setState({training_certification_staff_payments_international: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/ordens/pagamento/lista/treinamentos';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
            self.setState({payment_orders_list: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
      }); /* Overlay */ }); /* Lista de ordens de pagamento diarias internacionais */ }); /* Lista de ordens de pagamento diarias nacionais */
    });
  }


  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <Tabs activeKey={this.state.key} onSelect={this.handleNavTab.bind(this, 'key')} id="controlled-tab-example">
        <Tab eventKey={1} title="Nacional">
          <PaymentDailyOpenedNational handleAlert={this.handleAlert} training_certification_staff_payments_national={this.state.training_certification_staff_payments_national} payment_orders_list={this.state.payment_orders_list} modalPropsOff={this.state.modalPropsOff} showModal={this.state.showModal} />
        </Tab>
        <Tab eventKey={2} title="Internacional">
          <PaymentDailyOpenedInternational handleAlert={this.handleAlert} training_certification_staff_payments_international={this.state.training_certification_staff_payments_international} payment_orders_list={this.state.payment_orders_list} modalPropsOff={this.state.modalPropsOff} showModal={this.state.showModal} />
        </Tab>
      </Tabs>
    </div>
  </div>
</div>
    );
  }
}

export default PaymentDailyOpened;



// WEBPACK FOOTER //
// ./src/Components/TrainingCertificationStaffPayments/PaymentDailyOpened.js